<script>
	import { page } from '$app/stores';
	/**
	 * @typedef {Object} Props
	 * @property {import('svelte').Snippet} [children]
	 */

	/** @type {Props & { [key: string]: any }} */
	let { ...props } = $props();

	let rootPage = $derived($page.route.id?.includes('bottomNav'));
</script>

<div class="container" class:largeScreen={rootPage} style={props.style}>
	{@render props.children?.()}
</div>

<style>
	.container {
		position: relative;
		display: flex;
		gap: var(--gap);
		align-items: start;
		flex-direction: column;
		justify-content: start;
		flex: 1;
		width: 100%;
		/* max-width: 600px; */
		/* margin: 0 auto; */
		padding: var(--spacing-m);
		padding-bottom: 0;
		animation: slide-in 0.4s cubic-bezier(0.77, 0, 0.175, 1);
		transform: translateZ(0px);
	}

	@media (max-width: 768px) {
		.container {
			padding-top: 4rem;
		}
	}
	@media (min-width: 768px) {
		.container {
			padding: var(--spacing-m);
			padding-bottom: 0;
			justify-content: center;
			flex-direction: column;
			align-items: start;
			max-width: var(--max-width);
		}
	}
	@media (min-width: 1268px) {
		.largeScreen {
			padding: var(--spacing-m);
			padding-bottom: 0;
			justify-content: center;
			flex-direction: row;
			align-items: center;
			max-width: 1200px;
		}
	}
</style>
